import templates from "~/static/templates/$latest.json";
import _ from 'lodash';

export default function ({ store, $config: { templatesBaseUrl } }) {
  if (_.isEmpty(store.state.templates.templates)) {
    store.commit('templates/setTemplates', templates)
  }
}
